import * as React from "react";
import { BaseComponent } from "../../../react-core/Html/BaseComponent";

export interface ITableTempElementProps {}

export interface ITableTempElementState {
    isOpen?: boolean;
}

export class TableTempElement extends BaseComponent<ITableTempElementProps, ITableTempElementState> {
    constructor(props: ITableTempElementProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public render(): JSX.Element {
        return (
            <div className="table-skeleton full-width is-animated">
                <span className="sr-only">Loading data</span>
            </div>
        );
    }
}
